import { User } from 'types/user';

export const hasPrivilege = (
  privilege: { name: string },
  user: User | null,
): boolean => {
  if (user) {
    if (
      user.privileges &&
      user.privileges.some((p) => p.name === privilege.name)
    ) {
      return true;
    }

    if (
      user.roles &&
      user.roles.some((role) =>
        role.privileges.some((p) => p.name === privilege.name),
      )
    ) {
      return true;
    }

    if (user.group && user.group.roles) {
      if (
        user.group.roles.some((role) =>
          role.privileges.some((p) => p.name === privilege.name),
        )
      )
        return true;
    }

    return false;
  }
  return false;
};

export const isLoggedUserOrReplacement = (
  userIdToCheck: number,
  currentUser: User | null,
  allowedReplacements: number[],
) => (
    !!currentUser &&
    (currentUser.id === userIdToCheck ||
      allowedReplacements?.indexOf(userIdToCheck) !== -1)
  );

export const isLoggedUserOrReplacementByCode = (
  userCodeToCheck: string,
  currentUser: User | null,
  allowedReplacements: string[],
) => (
    !!currentUser &&
    (currentUser.code === userCodeToCheck ||
      allowedReplacements?.indexOf(userCodeToCheck) !== -1)
  );
